export class InternalEventData {
	/**
	 * The section within the app where the usage occurred.
	 */
	section?: string;
	/**
	 * The control that can be interacted with on the page. Preview page examples: Print, Download etc.
	 */
	component?: string;
	/**
	 * Text field. type of action. ex: click/view/key presses. If clicking the control multiple
	 */
	action?: string;
	/**
	 * Extra information about the event. Could be used for what the control is targeting/referring to.
	 */
	extra?: string;
	/**
	 * A count of the event. ex: key presses
	 */
	count?: string;
}
